module.exports = __webpack_public_path__ + "static/slide-1-89464ce6631493957db3453df61ee06c.jpg";